/* sk-vpick.js — Varianten-Picker im Silberkraft-CI (Philipp 04.11.2026) für die Bundle-Selects (snippets/sk-snocks-bundle-item).
   <sk-vpick> um das native <select> (bleibt Formularfeld, ohne JS sichtbar) + Feld-Button + <template data-sk-vpick-tpl> mit der
   serverseitig gerenderten Kaufbox-Staffel (snippets/sk-pdp-options-listview-bundle → Preise, −%-Chips, „Du sparst“, Grundpreis,
   Bestseller-/Empfehlungs-Badges 1:1 wie PDP). Auswahl = select.value + change-Event → sk-snocks.js rechnet Bundle-Preis/-Ersparnis
   und legt mit Rabattcode in den Warenkorb wie bisher. Panel im <body> (Desktop Popover unter dem Feld, Mobil Bottom-Sheet) →
   kein Clipping durch den Slider-Track (overflow) und kein Maus-Drag (sk-snocks.js überspringt Buttons).
   Bedienung: Klick/Space auf Zeile = wählen + schließen, Pfeiltasten = wählen (Panel bleibt), Enter = schließen, Esc = zurück zur
   vorherigen Auswahl + schließen, × / Klick daneben / Scrollen = schließen; Fokus zurück auf das Feld. Staffel-CSS: .sk-skl-compact (sk-drawer.css). */
(function () {
  'use strict';
  if (typeof document === 'undefined' || (window.customElements && customElements.get('sk-vpick'))) return;
  var MQ_SHEET = '(max-width: 639px)';
  var pop = null, panel = null, body = null, titleEl = null, st = null, seq = 0;

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  /* Kompakter Variantenname (Philipp 04.11.): Muster „6 Lieferungen je N Karten (M Karten gesamt)“ → „6 × N Karten“ + „M Karten gesamt“;
     alles andere behält seinen Titel (nur Klammerzusatz als Zusatzzeile) – nichts wird erfunden. */
  function compactParts(t) {
    t = String(t || '').trim();
    var m = t.match(/^(\d+)\s+Lieferung(?:en)?\s+je\s+(\d+)\s+(Karten?)\s*\((\d+)\s+Karten\s+gesamt\)\s*$/i);
    if (m) return { main: m[1] + ' \u00d7 ' + m[2] + ' ' + m[3], sub: m[4] + ' Karten gesamt' };
    /* Pflanzen „Lieferform / Größe“ (z. B. „Topf / 80–100 cm“) → „80–100 cm · Topf“ (nur umgestellt) */
    var sl = t.match(/^([^\/]+?)\s*\/\s*([^\/]+)$/);
    if (sl) { var a = sl[1].trim(), b = sl[2].trim(); return { main: b.toLowerCase().indexOf(a.toLowerCase()) >= 0 ? b : b + ' \u00b7 ' + a, sub: '' }; }
    var k = t.match(/^(.*?)\s*\(([^)]*)\)\s*$/);
    if (k && k[1]) return { main: k[1].trim(), sub: k[2].trim() };
    return { main: t, sub: '' };
  }
  function compact(t) { return compactParts(t).main; }

  function ensurePop(host) {
    if (pop) return;
    pop = document.createElement('div');
    pop.className = 'sk-vpick-pop';
    pop.setAttribute('data-sk-vpick-pop', '');
    pop.hidden = true;
    pop.innerHTML =
      '<div class="sk-vpick-pop__backdrop" data-sk-vpick-close></div>' +
      '<div class="sk-vpick-pop__panel sk-skl-compact" role="dialog" aria-modal="true" aria-labelledby="sk-vpick-title" tabindex="-1">' +
        '<div class="sk-vpick-pop__head">' +
          '<span class="sk-vpick-pop__eyebrow" data-sk-vpick-eyebrow></span>' +
          '<button type="button" class="sk-vpick-pop__close" data-sk-vpick-close>' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
          '<span class="sk-vpick-pop__title" id="sk-vpick-title" data-sk-vpick-title></span>' +
        '</div>' +
        '<div class="sk-vpick-pop__body" data-sk-vpick-body></div>' +
      '</div>';
    document.body.appendChild(pop);
    panel = q('.sk-vpick-pop__panel', pop);
    body = q('[data-sk-vpick-body]', pop);
    titleEl = q('[data-sk-vpick-title]', pop);
    pop.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;
      if (e.target.closest('[data-sk-vpick-close]')) { e.preventDefault(); close(); return; }
      /* Zeiger-Klick auf eine Zeile = wählen + schließen (change feuert nach dem Label-Klick). Tastatur (Pfeile/Space) löst am
         Radio ebenfalls ein click-Ereignis aus, aber mit detail 0 → Panel bleibt offen, Enter/Esc schließen. */
      var row = e.target.closest('.skl__row');
      if (row && st && e.detail > 0) setTimeout(function () { if (st) close(); }, 0);
    });
    pop.addEventListener('change', function (e) {
      var r = e.target;
      if (!st || !(r instanceof HTMLInputElement) || r.type !== 'radio' || !r.checked) return;
      var v = selectedVariant();
      if (v) st.host.apply(String(v.id));
      var hd = q('[data-selected-variant-title]', body);
      if (hd && v) hd.textContent = v.t;
    });
    /* Capture-Phase am Dokument: Esc muss VOR fremden Escape-Handlern (Theme-Dialoge, Drawer) laufen, sonst schließt ein
       dadurch ausgelöster Scroll das Panel ohne Rücksetzen der Auswahl */
    document.addEventListener('keydown', function (e) {
      if (!st) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); var h = st.host, o = st.orig; close(); h.apply(o); return; }
      if (!panel.contains(e.target)) return;
      if (e.key === 'Enter') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = qa('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', panel);
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
    }, true);
    window.addEventListener('resize', function () { if (st) close(); });
    window.addEventListener('scroll', function (e) { if (st && !pop.classList.contains('sk-vpick-pop--sheet') && !(e.target instanceof Element && panel.contains(e.target))) close(); }, true);
    document.addEventListener('sk:variant-rendered', function () { if (st) close(); });
  }

  function selectedVariant() {
    var checked = qa('input[type="radio"]:checked', body);
    if (!checked.length || !st) return null;
    /* Zeilen mit direkter Varianten-ID (Mehr-Options-Produkte, snippets/sk-snocks-bundle-item) */
    if (checked[0].hasAttribute('data-sk-vid')) return st.host.variantById(checked[0].getAttribute('data-sk-vid'));
    var want = {};
    checked.forEach(function (r) { want[parseInt(r.getAttribute('data-variant-option-value-index') || '0', 10)] = r.value; });
    var idx = Object.keys(want);
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      if (idx.every(function (k) { return (v.o || [])[k] === want[k]; })) return v;
    }
    var row = checked[0].closest('.skl__row');
    var t = row ? row.getAttribute('data-formatted-title') : null;
    for (var j = 0; j < st.variants.length; j++) if (st.variants[j].t === t) return st.variants[j];
    return null;
  }

  function place(btn) {
    var sheet = window.matchMedia(MQ_SHEET).matches;
    pop.classList.toggle('sk-vpick-pop--sheet', sheet);
    panel.style.top = panel.style.bottom = panel.style.left = panel.style.width = panel.style.maxHeight = '';
    if (sheet) return;
    var r = btn.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    /* Breite 420–460 px bzw. Feldbreite, nie über den Viewport; rechtsbündig am Feld, wenn links nicht genug Platz */
    var w = Math.min(Math.max(420, r.width), 460, vw - 16);
    var left = r.left;
    if (left + w > vw - 8) left = Math.max(8, r.right - w);
    if (left + w > vw - 8) left = Math.max(8, vw - 8 - w);
    var below = vh - r.bottom - 12, above = r.top - 12;
    var useBelow = below >= 300 || below >= above;
    var maxH = Math.max(200, Math.min(560, useBelow ? below : above));
    panel.style.left = left + 'px';
    panel.style.width = w + 'px';
    panel.style.maxHeight = maxH + 'px';
    if (useBelow) panel.style.top = (r.bottom + 6) + 'px';
    else panel.style.bottom = (vh - r.top + 6) + 'px';
  }

  function open(host) {
    ensurePop(host);
    if (st) close(true);
    var tpl = host.tpl, sel = host.sel, btn = host.btn;
    if (!tpl || !sel || !btn) return false;
    var frag = document.importNode(tpl.content, true);
    var dataEl = frag.querySelector('[data-sk-vpick-variants]');
    if (dataEl && dataEl.parentNode) dataEl.parentNode.removeChild(dataEl);
    body.innerHTML = '';
    body.appendChild(frag);
    qa('.skl', body).forEach(function (s) { s.removeAttribute('data-skl-collapsible'); s.setAttribute('data-skl-expanded', 'true'); });
    qa('[data-skl-toggle]', body).forEach(function (t) { t.parentNode.removeChild(t); });
    var name = 'sk-vpick-' + (++seq) + '-';
    qa('.skl__row', body).forEach(function (row) {
      var inp = row.querySelector('input[type="radio"]');
      if (!inp || inp.disabled || row.classList.contains('skl__row--oos') || row.classList.contains('skl__row--amz')) { row.parentNode.removeChild(row); return; }
      inp.checked = false;
      inp.name = name + inp.name;
    });
    if (!q('.skl__row input[type="radio"]', body)) return false;
    qa('.skl__row', body).forEach(function (row) {
      /* Badges (Bestseller/Empfehlung) in die Textspalte über den Titel – nie über dem Preis (Philipp 04.11.) */
      var main = q('.skl__main', row);
      qa('.skl__best-badge, .skl__rec-badge', row).forEach(function (b) { if (main) main.insertBefore(b, main.firstChild); });
      var tt = q('.skl__title', row); if (!tt) return;
      var ft = row.getAttribute('data-formatted-title') || tt.textContent;
      /* Nur-Zahl-Titel (z. B. Dünger „Menge“ 1/2/4/20) → Optionstext des Selects („Menge: 1“), wie im Feld */
      if (/^\s*\d+\s*$/.test(ft)) { var vv = null; for (var i = 0; i < host.variants.length; i++) if (host.variants[i].t === ft) { vv = host.variants[i]; break; } var oo = vv && sel.querySelector('option[value="' + vv.id + '"]'); if (oo) ft = oo.textContent.trim(); }
      var cp = compactParts(ft);
      tt.textContent = cp.main;
      if (cp.sub) { var sub = document.createElement('span'); sub.className = 'skl__title-sub'; sub.textContent = cp.sub; tt.appendChild(sub); }
    });
    st = { host: host, variants: host.variants, orig: sel.value };
    /* aktuelle Auswahl des Selects vorwählen (über Variantentitel ↔ Zeile), sonst erste Zeile */
    var cur = host.variantById(sel.value);
    var pre = null;
    if (cur) pre = qa('.skl__row', body).filter(function (r) { return r.getAttribute('data-formatted-title') === cur.t; }).map(function (r) { return r.querySelector('input[type="radio"]'); })[0];
    if (!pre) pre = q('.skl__row input[type="radio"]', body);
    if (pre) pre.checked = true;
    var hd = q('[data-selected-variant-title]', body);
    if (hd && cur) hd.textContent = cur.t;
    q('[data-sk-vpick-eyebrow]', pop).textContent = host.getAttribute('data-l-choose') || 'Variante wählen';
    q('[data-sk-vpick-close]', panel).setAttribute('aria-label', host.getAttribute('data-l-close') || 'Schließen');
    titleEl.textContent = host.getAttribute('data-title') || '';
    place(btn);
    pop.hidden = false;
    document.documentElement.classList.add('sk-vpick-open');
    btn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { pop.setAttribute('data-open', ''); });
    setTimeout(function () { if (!st) return; var f = q('input[type="radio"]:checked', body); try { (f || panel).focus({ preventScroll: true }); } catch (_) { panel.focus(); } }, 40);
    return true;
  }

  function close(silent) {
    if (!st) return;
    var host = st.host;
    st = null;
    pop.removeAttribute('data-open');
    document.documentElement.classList.remove('sk-vpick-open');
    host.btn.setAttribute('aria-expanded', 'false');
    var sheet = pop.classList.contains('sk-vpick-pop--sheet');
    setTimeout(function () { if (!st) { pop.hidden = true; body.innerHTML = ''; } }, sheet ? 260 : 160);
    if (!silent) { try { host.btn.focus({ preventScroll: true }); } catch (_) {} }
  }

  class SkVpick extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.sel = q('select', this);
      this.btn = q('[data-sk-vpick-btn]', this);
      this.tpl = q('template[data-sk-vpick-tpl]', this);
      var dataEl = this.tpl && this.tpl.content.querySelector('[data-sk-vpick-variants]');
      try { this.variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (_) { this.variants = []; }
      this.rows = {};
      if (this.tpl) qa('.skl__row', this.tpl.content).forEach(function (r) { self.rows[r.getAttribute('data-formatted-title')] = { d: parseInt(r.getAttribute('data-discount-percent') || '0', 10) || 0 }; });
      if (!this.sel || !this.btn || !this.tpl || !this.variants.length) return;
      this.sel.setAttribute('tabindex', '-1');
      this.sel.setAttribute('aria-hidden', 'true');
      /* Slider-Drag, der auf dem Feld beginnt (sk-snocks.js überspringt Buttons): Press → ≥ 8 px bewegen → loslassen öffnet NICHT */
      var down = null;
      this.btn.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY }; });
      this.btn.addEventListener('click', function (e) {
        e.preventDefault();
        var moved = down && e.clientX != null && (Math.abs(e.clientX - down.x) >= 8 || Math.abs(e.clientY - down.y) >= 8) && e.detail > 0;
        down = null;
        if (moved) return;
        if (st && st.host === self) close(); else open(self);
      });
      this.btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(self); } });
      this.sel.addEventListener('change', function () { self.sync(); });
      this.sync();
    }
    variantById(id) {
      for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
      return null;
    }
    apply(id) {
      if (!this.sel || this.sel.value === String(id)) return;
      this.sel.value = String(id);
      this.sel.dispatchEvent(new Event('change', { bubbles: true }));
      this.sync();
    }
    sync() {
      var o = this.sel && this.sel.selectedOptions[0];
      if (!o) return;
      var v = this.variantById(o.value);
      var lbl = q('[data-sk-vpick-lbl]', this.btn), pr = q('[data-sk-vpick-price]', this.btn), chip = q('[data-sk-vpick-chip]', this.btn);
      if (lbl) lbl.textContent = compact(o.textContent);
      if (pr) pr.textContent = o.getAttribute('data-price-text') || '';
      var d = v && this.rows[v.t] ? this.rows[v.t].d : 0;
      if (chip) { chip.textContent = d > 0 ? '\u2212' + d + '%' : ''; chip.hidden = !(d > 0); }
    }
  }
  customElements.define('sk-vpick', SkVpick);
  document.documentElement.classList.add('sk-vpick-ready');
})();
